<div
  class="wk8-paper-piece"
  style="
    position: relative;
    transition:
      scale 0.25s var(--ease-in-out-back),
      filter 0.25s ease;
  "
  [style]="{
    scale: hasFocus() ? 1.2 : 1,
    filter: hasFocus() ? 'drop-shadow(0 0 10px #000)' : undefined,
  }"
>
  <app-nine-sliced-sprite
    src="/assets/woordkr8/paper-piece.png"
    width="8px"
    [x]="[0.4, 0.7]"
    [y]="[0.2, 0.8]"
    style="position: absolute; width: 100%; height: 100%"
  />
  @let _paddingLeft = paddingLeft() ?? padding();
  @let _paddingRight = paddingRight() ?? padding();
  <div
    class="content"
    style="position: relative; font-family: Lexy2000"
    [style]="{
      'padding-left': _paddingLeft === 'NONE' ? undefined : _paddingLeft === 'SMALL' ? '0.125em' : '0.5em',
      'padding-right': _paddingRight === 'NONE' ? undefined : _paddingRight === 'SMALL' ? '0.125em' : '0.5em',
      transition: 'padding 0.25s var(--ease-in-back)',
    }"
  >
    <ng-content></ng-content>
  </div>
</div>
